import { combineReducers } from 'redux'
import promotions from './promotions'
import restaurants from './restaurants'
export default combineReducers({
  promotions,
  restaurants,
 
})
 